import { useEffect } from "react";
import { isAuthenticationError } from "./error";
import { logDataToSentry } from "./sentry";

export const useReportLoadError = (error: Error | undefined | null) => {
	useEffect(() => {
		if (!error || isAuthenticationError(error)) return;

		if (process.env.VITE_SENTRY_ENV === "prod") {
			console.error("An error occurred: ", error.message);
		}

		logDataToSentry(error.name, {
			message: error.message,
			stack: error.stack,
		});
	}, [error]);
};
